import { combineReducers } from "redux";

import userReducer from "./user.slice";
import studentReducer from "./student.slice";
import teacherReducer from "./teacher.slice";
import contentReducer from "./content.slice";
import genericReducer from "./generics.slice";
import calendarReducer from "./calendar.slice";
import affiliateReducer from "./affiliate.slice";
import methodologyReducer from "./methodology.slice";
import b2bCouponsReducer from "./b2b/b2bCoupons.slice";
import companyManagerReducer from "./companyManager.slice";
import questionnairesReducer from "./questionnaires.slice";
import b2bCompaniesReducer from "./b2b/b2bCompanies.slice";
import b2bContractsReducer from "./b2b/b2bContracts.slice";
import customerServiceReducer from "./customerService.slice";
import contentExercisesReducer from "./contentExercises.slice";

export const rootReducer = combineReducers({
  userReducer,
  genericReducer,
  studentReducer,
  teacherReducer,
  contentReducer,
  calendarReducer,
  affiliateReducer,
  b2bCouponsReducer,
  methodologyReducer,
  b2bCompaniesReducer,
  b2bContractsReducer,
  companyManagerReducer,
  questionnairesReducer,
  customerServiceReducer,
  contentExercisesReducer,
});
